import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import logo from '../img/logoEducativa.png';
import Container from '@mui/material/Container';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import { RecaptchaKey } from '../Keys'
import { toast } from 'react-toastify';
import { loginToken } from '../Redux/token'
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, IconButton } from '@mui/material';
import { UserAuth } from '../context/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';


const schema = yup.object().shape({
    // nombre: yup.string().required('El nombre es requerido'),
    // apellido: yup.string().required('El apellido es requerido'),
    // cuitcuil: yup.string().required('El cuit/cuil es requerido'),
    correo: yup.string().email('El correo electrónico no es válido').required('El correo electrónico es requerido'),
    password: yup.string().min(4, 'La contraseña debe tener al menos 4 caracteres').
        max(15, 'La contraseña no puede serperar los 15 caracteres').required('La contraseña es requerida'),
    repassword: yup.string().oneOf([yup.ref('password'), 'Las contraseñas deben coincidir']),
    opcion: yup.string().required('Este campo es obligatorio'),
});

const Registrar = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const token = useSelector(store => store.token.token)
    
    const resultado = useSelector(store => store.usuarios.resultado)
    const [desabilitarRegistro, setDesabilitarRegistro] = React.useState(false)
    const [robot, setRobot] = React.useState(false)
    
    const [showPassword, setShowPassword] = React.useState(false);

    const { createUser, loadingRegistro } = UserAuth()

    React.useEffect(() => {
        if (token == undefined || token == "") {
            dispatch(loginToken())
        }
    }, [token])

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmitHandler = async (data) => {
        // if (!robot) {
        //     toast.error('Debes confirmar que no eres un robot!', {
        //         theme: "dark",
        //         position: "top-center",
        //         autoClose: 2000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //     });
        //     return
        // }
        try {
            await createUser(data, token.token)
            navigate('/inicio')
        } catch (error) {
            toast.error(error.message, {
                theme: "dark",
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            // console.log(error.message)
        }
        console.log(data, token.token)
    };

    // const robotOnChange = (value) => {
    //     var valor = ""
    //     if (value) {
    //         valor = "True"
    //         setRobot(true)
    //     } else {
    //         valor = "False"
    //         setRobot(false)
    //     }
    // }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    //loader en boton
    const buttonSx = {
        ...(loadingRegistro && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };


    return (
        <Container component="main" maxWidth="sm">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'center', }} gap="0.5rem">
                    <img src={logo} alt="Logo" style={{ height: "4rem" }} />
                </Box>
                <Typography component="h1" variant="h5" sx={{ mb: 2, mt: 4 }}>
                    Crear Cuenta
                </Typography>
                <form onSubmit={handleSubmit(onSubmitHandler)}>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="nombre"
                                label="Nombre"
                                {...register("nombre")}
                                helperText={errors.nombre?.message}
                                error={errors.nombre}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="apellido"
                                label="Apellido"
                                {...register("apellido")}
                                helperText={errors.apellido?.message}
                                error={errors.apellido}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                id="CUIT/CUIL"
                                label="CUIT/CUIL"
                                {...register("cuitcuil")}
                                helperText={errors.cuitcuil?.message}
                                error={errors.cuitcuil}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12}>
                            <TextField
                                fullWidth
                                id="correo"
                                label="Correo Electrónico"
                                {...register("correo")}
                                helperText={errors.correo?.message}
                                error={errors.correo}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Puesto</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    {...register("opcion")}
                                >
                                    <MenuItem value="codocente">Codocente</MenuItem>
                                    <MenuItem value="docente">Docente</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="password"
                                label="Contraseña"
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                {...register("password")}
                                helperText={errors.password?.message}
                                error={errors.password}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id="repassword"
                                label="Repetir Contraseña"
                                type={showPassword ? 'text' : 'password'}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                {...register("password")}
                                helperText={errors.password?.message}
                                error={errors.password}
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
                            <ReCAPTCHA
                                size={12}
                                className=""
                                render="explicit"
                                sitekey={RecaptchaKey}
                                onChange={e => robotOnChange(e)} />
                        </Grid> */}
                    </Grid>
                    <Box sx={{ mt: 3, mb: 2, position: 'relative' }}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={buttonSx}
                            disabled={loadingRegistro}
                        >
                            Crear cuenta
                        </Button>
                        {loadingRegistro && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    color: green[500],
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-12px',
                                    marginLeft: '-12px',
                                }}
                            />
                        )}

                    </Box>
                    <Box component="form" noValidate sx={{ mt: 1, mb: 3 }}>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Link href="/" variant="body1" color={"#fefefe"}>
                                    Ya tienes una cuenta? Inicia sesion
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </form>
            </Box>
        </Container>
    );
};

export default Registrar;